import {BrowserRouter, Route, Routes} from "react-router";
import Homepage from "./routes/homepage";
import LexicorderCategories from "./routes/lexicorder/categories";
import LexicorderDatepicker from "./routes/lexicorder/datepicker";
import Lexicorder from "./routes/lexicorder/lexicorder";
import NumericorderCategories from "./routes/numericorder/categories";
import NumericorderDatepicker from "./routes/numericorder/datepicker";
import Numericorder from "./routes/numericorder/numericorder";

export default function App() {

    return <BrowserRouter>
        <Routes>
            <Route path="/" element={<Homepage/>}/>
            <Route path="/lexicorder" element={<LexicorderCategories/>}/>
            <Route path="/lexicorder/:category" element={<LexicorderDatepicker/>}/>
            <Route path="/lexicorder/:category/:date" element={<Lexicorder/>}/>
            <Route path="/numericorder" element={<NumericorderCategories/>}/>
            <Route path="/numericorder/:category" element={<NumericorderDatepicker/>}/>
            <Route path="/numericorder/:category/:date" element={<Numericorder/>}/>
        </Routes>
    </BrowserRouter>;

}
